export default "__VITE_ASSET__BAgYARse__"